/*
  Base file for index file in component.
  A short description can go here, but more
  detailed info can be placed in the README.
*/

// IMPORTS GO HERE
import _ from 'underscore';
import $ from 'jquery';
import {setElementsFromScope} from '../../utilities/selectorHelpers';
import {instantiateSelect2} from '../../utilities/select2able';
import render from '../../utilities/render';
const pagingHtml = require('./html/pagingArea.html');
const pageSelectHtml = require('./html/pageSelect.html');
const pagingButtonsHtml = require('./html/pagingButtons.html');
const pageTrayHtml = require('./html/pageTray.html');
const loaderOverlayHtml = require('../../sharedHtml/loaderOverlay.html');
require("./pagableComponent.less");

export default function PagableComponent(options={}) {
  // functional code for component here
  let self = this;
  let defaults = {
    pageSizeOptions: [10,25,50,100],
    pageSize: 10
  }
  const settings = _.extend(defaults, options);
  const dataContainer = $(settings.dataContainer);
  const pagingContainer = $(settings.pagingContainer);
  const els = {};
  const elementsMap = {
    pageSelect: '.page-select',
    pageInfo: '.page-info',
    navBtnWrap: '.nav-btn-wrap',
    loadingOverlay: '.loading-overlay'
  };
  
  let totalRows = settings.data.totalElements;
  let pageSizeOptions = settings.pageSizeOptions;
  let pageSize = settings.pageSize;
  let currentPageNumber = settings.data.page;
  let pagingData = settings.data.content || [];
  let pageTrayElements;
  let totalPages = getTotalPages();

  function getTotalPages(){
    return Math.ceil(totalRows/pageSize);
  }
  
  self.init = function (){
    setInitialState();
    buildHtml();
    setElements();
    bindElements();
    instantiateSelect2($('.page-select'));
  }
  
  function setElements(){
    setElementsFromScope(els, elementsMap, pagingContainer);
  }
  
  function bindElements(){
    els.pageSelect.on('change', onPageSelectChange);
    els.navBtnWrap.on('click', '.page-num', onPageNumClick);
    els.navBtnWrap.on('click', '.next-btn', onNextBtnClick);
    els.navBtnWrap.on('click', '.prev-btn', onPrevBtnClick);
  }
  
  function onPageSelectChange(){
    pageSize = parseInt(els.pageSelect.val());
    totalPages = getTotalPages();
    currentPageNumber = 0;
    getData();
    updatePagingArea();
  }
  
  function onPageNumClick(e){
    e.preventDefault();
    let pageNumClicked = $(this).data('page-num');
    if(currentPageNumber != pageNumClicked){
      currentPageNumber = pageNumClicked
      getData();
      updatePagingArea();      
    }
  }
  
  function onNextBtnClick(){
    if(currentPageNumber == totalPages - 1){
      els.navBtnWrap.find('.next-btn').addClass('quick-shake');
      setTimeout(()=>{
        els.navBtnWrap.find('.next-btn').removeClass('quick-shake');
      }, 500);
    } else {
      currentPageNumber++;
      getData();
      updatePagingArea();
    }
  }
  
  function onPrevBtnClick(){
    if(currentPageNumber == 0){
      els.navBtnWrap.find('.prev-btn').addClass('quick-shake');
      setTimeout(()=>{
        els.navBtnWrap.find('.prev-btn').removeClass('quick-shake');
      }, 500);
    } else {
      currentPageNumber--;
      getData();
      updatePagingArea();
    }
  }
  
  function setInitialState(){
    if(!_.contains(pageSizeOptions, pageSize)){
      pageSize = pageSizeOptions[0];
    }
  }
  
  function getData(){
    settings.onFetch && settings.onFetch(currentPageNumber, pageSize);
  }
  
  function buildHtml(){
    renderPagingArea();
    renderDataRows();
  }
  
  function renderPagingArea(){
    const pagingArea = render(pagingHtml, {
      pageSelect: renderPageSelect(),
      pageInfo: renderPageInfoText(),
      pageButtons: renderPageButtons(),
      loaderOverlay: loaderOverlayHtml
    });
    pagingContainer.html(pagingArea);
  }
  
  function renderPageSelect(){
    const pageOptionHtml =  _(pageSizeOptions).map((pageOption)=>{
      return render(pageSelectHtml, {
        pageData: pageOption,
        pageSize: pageSize
      });
    });
    return pageOptionHtml.join('');
  }
  
  function renderPageInfoText(){
    return`Showing ${exclusiveResultsShownTotal()}-${computedInclusiveResultsShownTotal()} of ${totalRows}`;
  }

  function exclusiveResultsShownTotal(){
    return (currentPageNumber * pageSize) + 1;
  }
  
  function computedInclusiveResultsShownTotal(){
    if(isBeforeLastPage()){
      return inclusiveResultsShownTotal();
    } else {
      return totalRows;
    }
  }
  
  function isBeforeLastPage(){
    return totalRows > inclusiveResultsShownTotal();
  }
  
  function inclusiveResultsShownTotal(){
    return pageSize * (currentPageNumber + 1);
  }
  
  function renderPageButtons(){
    return render(pagingButtonsHtml, {
      pageNumTray: generatePageNumTray()
    });
  }
  
  function generatePageNumTray(){
    const pageNumTrayHtml = generatePageElements().map((pageNumElements)=>{
      const isLink = (pageNumElements === '...') ? false : true;
      return render(pageTrayHtml, {
        pageNumber: pageNumElements,
        link: isLink,
        currentPage: currentPageNumber
      });
    });
    return pageNumTrayHtml.join('');
  }
  
  function generatePageElements(){
    pageTrayElements = [];
    if(totalPages > 6){
      if(currentPageNumber <=2){
        pageTrayElements = ['1','2','3','...',totalPages];
      }else if(currentPageNumber >= 3 && currentPageNumber < totalPages - 3){
        pageTrayElements = ['1','...',currentPageNumber,currentPageNumber + 1,currentPageNumber + 2,'...',totalPages];
      }else{
        pageTrayElements = ['1','...',totalPages - 2,totalPages - 1,totalPages];
      }
    } else {
      _(totalPages).times((page)=>{
        pageTrayElements.push(page+1);
      });
    }
    return pageTrayElements;
  }
  
  function updatePagingArea(){
    els.pageInfo.html(renderPageInfoText());
    els.navBtnWrap.html(renderPageButtons());
  }
  
  function renderDataRows(){
    dataContainer.html('');
    _(pagingData).each((el)=>{
      dataContainer.append(settings.showData(el));
    });
  }

  self.setData = function(moreData){
    pagingData = moreData;
    renderDataRows();
  }
  
  self.showLoadingOverlay = function(){
    showLoadingOverlay(); 
  }
  
  self.hideLoadingOverlay = function (){
    hideLoadingOverlay();
  }
  
  function showLoadingOverlay(){
    els.loadingOverlay.show();
  }
  
  function hideLoadingOverlay(){
    els.loadingOverlay.hide();
  }

};


// WEBPACK FOOTER //
// ./src/components/pagableComponent/index.js